import { render, staticRenderFns } from "./garden_enter5.vue?vue&type=template&id=b49ed032&scoped=true&"
import script from "./garden_enter5.vue?vue&type=script&lang=js&"
export * from "./garden_enter5.vue?vue&type=script&lang=js&"
import style0 from "./garden_enter5.vue?vue&type=style&index=0&id=b49ed032&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49ed032",
  null
  
)

export default component.exports